var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
// MapsPage.tsx
import React, { useEffect, useState, useCallback, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import SubNavHeader from '../Nav/SubNavHeader';
import MapsListComponent from './MapList';
import { AppContext } from '../index';
var MapsPage = function (_a) {
    var selectedMap = _a.selectedMap, setSelectedMap = _a.setSelectedMap;
    var mapListType = useParams().mapListType;
    var navigate = useNavigate();
    var _b = useContext(AppContext), teamMaps = _b.teamMaps, personalMaps = _b.personalMaps, apiDomain = _b.apiDomain, t = _b.t;
    var _c = __read(useState(null), 2), mapsList = _c[0], setMapsList = _c[1];
    var _d = __read(useState(false), 2), fetchingMaps = _d[0], setFetcingMaps = _d[1];
    var _e = __read(useState(true), 2), firstLoaded = _e[0], setFirstLoaded = _e[1];
    var fetchMaps = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var fetchedMaps, maps, mapsNull, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (personalMaps.current) {
                        setMapsList(personalMaps.current);
                        return [2 /*return*/];
                    }
                    else {
                        setMapsList(null);
                    }
                    if (fetchingMaps)
                        return [2 /*return*/];
                    setFetcingMaps(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch("".concat(apiDomain, "/account/maps"), {
                            credentials: 'include',
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })];
                case 2:
                    fetchedMaps = _a.sent();
                    if (!fetchedMaps.ok) {
                        throw new Error("HTTP error! status: ".concat(fetchedMaps.status));
                    }
                    return [4 /*yield*/, fetchedMaps.json()];
                case 3:
                    maps = _a.sent();
                    mapsNull = personalMaps.current == null;
                    personalMaps.current = maps.reverse();
                    setMapsList(personalMaps.current);
                    setFetcingMaps(false);
                    if (firstLoaded && maps.length == 0) {
                        navigate('/editor');
                        setFirstLoaded(false);
                    }
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    setMapsList(null);
                    setFetcingMaps(false);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [personalMaps, fetchingMaps]);
    var _f = __read(useState(false), 2), fetchingTeamMaps = _f[0], setFetcingTeamMaps = _f[1];
    var fetchTeamMaps = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var fetchedMaps, _a, error_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (teamMaps.current) {
                        setMapsList(teamMaps.current);
                        return [2 /*return*/];
                    }
                    else {
                        setMapsList(null);
                    }
                    if (fetchingTeamMaps)
                        return [2 /*return*/];
                    setFetcingTeamMaps(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch("".concat(apiDomain, "/account/maps/team"), {
                            credentials: 'include',
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })];
                case 2:
                    fetchedMaps = _b.sent();
                    if (!fetchedMaps.ok) {
                        throw new Error("HTTP error! status: ".concat(fetchedMaps.status));
                    }
                    _a = teamMaps;
                    return [4 /*yield*/, fetchedMaps.json()];
                case 3:
                    _a.current = _b.sent();
                    teamMaps.current.reverse();
                    setMapsList(teamMaps.current);
                    setFetcingTeamMaps(false);
                    return [3 /*break*/, 5];
                case 4:
                    error_2 = _b.sent();
                    setMapsList(null);
                    setFetcingTeamMaps(false);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [teamMaps, fetchingTeamMaps]);
    var changeMapListType = useCallback(function (type) {
        setSelectedMap(null);
        navigate("/maps/".concat(type));
    }, [navigate, setSelectedMap]);
    useEffect(function () {
        if (mapListType === 'personal') {
            fetchMaps();
        }
        else if (mapListType === 'team') {
            fetchTeamMaps();
        }
    }, [mapListType, fetchMaps, fetchTeamMaps]);
    return (React.createElement(React.Fragment, null,
        React.createElement(SubNavHeader, { items: [{ type: 'personal', label: t('map_list.personal') }, { type: 'team', label: t('map_list.team') }], selected: mapListType, click: changeMapListType }),
        React.createElement(MapsListComponent, { mapsList: mapsList })));
};
export default MapsPage;
